/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
/**
* CSS Custom Properties
*
* These properties can be overridden using the component's tag as selector.
*
* @prop --calcite-accordion-border-color: [Deprecated] Use `--calcite-accordion-item-border-color`. Specifies the component's border color.
* @prop --calcite-accordion-item-background-color: Specifies the component's background color.
* @prop --calcite-accordion-item-border-color: Specifies the component's border color.
* @prop --calcite-accordion-item-content-space: Specifies the component's padding.
* @prop --calcite-accordion-item-end-icon-color: Specifies the component's `iconEnd` color. Fallback to `--calcite-accordion-item-icon-color` or current color.
* @prop --calcite-accordion-item-expand-icon-color: Specifies the component's expand icon color.
* @prop --calcite-accordion-item-header-background-color: Specifies the component's `heading` background color.
* @prop --calcite-accordion-item-heading-text-color: Specifies the component's `heading` text color.
* @prop --calcite-accordion-item-icon-color: Specifies the component's default icon color.
* @prop --calcite-accordion-item-start-icon-color: Specifies the component's `iconStart` color. Fallback to `--calcite-accordion-item-icon-color` or current color.
* @prop --calcite-accordion-item-text-color: Specifies the component's text color.
* @prop --calcite-accordion-text-color-hover: [Deprecated] Use `--calcite-accordion-item-text-color-hover`. Specifies the component's main text color on hover.
* @prop --calcite-accordion-text-color-pressed: [Deprecated] Use `--calcite-accordion-item-text-color-press`. Specifies the component's main text color when pressed.
* @prop --calcite-accordion-text-color: [Deprecated] Use `--calcite-accordion-item-text-color`. Specifies the component's text color.
*/
.icon-position--end, .icon-position--start {
  /* icon rotation variables */
  --calcite-internal-accordion-item-icon-rotation: calc(90deg * -1);
  --calcite-internal-accordion-item-active-icon-rotation: 0deg;
  --calcite-internal-accordion-item-icon-rotation-rtl: 90deg;
  --calcite-internal-accordion-item-active-icon-rotation-rtl: 0deg;
}

:host {
  position: relative;
  display: flex;
  flex-direction: column;
  text-decoration-line: none;
  color: var(--calcite-accordion-item-text-color, var(--calcite-accordion-text-color, var(--calcite-color-text-3)));
  background-color: var(--calcite-accordion-item-background-color);
  border-width: 0;
}
:host .header {
  background-color: var(--calcite-accordion-item-header-background-color);
}

.icon-position--start {
  --calcite-internal-accordion-item-flex-direction: row-reverse;
  --calcite-internal-accordion-item-icon-spacing-start: 0;
  --calcite-internal-accordion-item-icon-spacing-end: var(--calcite-internal-accordion-icon-margin);
}

.icon-position--end {
  --calcite-internal-accordion-item-flex-direction: row;
  --calcite-internal-accordion-item-icon-spacing-start: var(--calcite-internal-accordion-icon-margin);
  --calcite-internal-accordion-item-icon-spacing-end: 0;
}

.icon-position--end:not(.icon-type--plus-minus) {
  --calcite-internal-accordion-item-icon-rotation: 0deg;
  --calcite-internal-accordion-item-active-icon-rotation: 180deg;
  --calcite-internal-accordion-item-icon-rotation-rtl: 0deg;
  --calcite-internal-accordion-item-active-icon-rotation-rtl: calc(180deg * -1);
}

.content,
.header {
  border-block-end-width: var(--calcite-border-width-sm);
  border-block-end-style: solid;
  border-color: var(--calcite-accordion-item-border-color, var(--calcite-accordion-border-color, var(--calcite-color-border-2)));
}

.header-content,
.content {
  padding: var(--calcite-accordion-item-content-space, var(--calcite-internal-accordion-item-padding, var(--calcite-internal-accordion-item-spacing-unit, 0.5rem 0.75rem)));
}

.header {
  display: flex;
  align-items: stretch;
}
.header * {
  display: inline-flex;
  align-items: center;
  transition-duration: 150ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  word-wrap: break-word;
  word-break: break-word;
}

.header-content {
  flex-grow: 1;
  cursor: pointer;
  outline-color: transparent;
  flex-direction: var(--calcite-internal-accordion-item-flex-direction);
  color: var(--calcite-accordion-item-heading-text-color, var(--calcite-accordion-text-color, inherit));
}
.header-content:focus {
  outline: 2px solid var(--calcite-ui-focus-color, var(--calcite-color-brand));
  outline-offset: calc(
            -2px *
            calc(
              1 -
              2 * clamp(
                0,
                var(--calcite-offset-invert-focus),
                1
              )
            )
          );
}
.header-content:focus, .header-content:hover, .header-content:active {
  color: var(--calcite-accordion-item-heading-text-color, var(--calcite-accordion-text-color-hover, var(--calcite-color-text-2)));
}
.header-content:focus .heading, .header-content:hover .heading, .header-content:active .heading {
  color: var(--calcite-accordion-item-heading-text-color, var(--calcite-accordion-text-color-pressed, var(--calcite-color-text-1)));
}

.header-container {
  inline-size: 100%;
}

.header-text {
  margin-block: 0px;
  flex-grow: 1;
  flex-direction: column;
  padding-block: 0px;
  text-align: initial;
  margin-inline-end: auto;
}

.heading,
.description {
  display: flex;
  inline-size: 100%;
}

.heading {
  font-weight: var(--calcite-font-weight-medium);
}

.actions-start,
.actions-end {
  display: flex;
  align-items: center;
}

.icon {
  display: flex;
  align-items: center;
  transition-duration: 150ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  margin-inline-end: var(--calcite-internal-accordion-item-icon-spacing-start);
  margin-inline-start: var(--calcite-internal-accordion-item-icon-spacing-end);
}

.icon--start {
  color: var(--calcite-accordion-item-start-icon-color, var(--calcite-accordion-item-icon-color, currentColor));
  margin-inline-end: var(--calcite-internal-accordion-icon-margin);
}

.icon--end {
  color: var(--calcite-accordion-item-end-icon-color, var(--calcite-accordion-item-icon-color, currentColor));
  margin-inline-end: var(--calcite-internal-accordion-icon-margin);
  margin-inline-start: var(--calcite-internal-accordion-icon-margin);
}

.expand-icon {
  color: var(--calcite-accordion-item-expand-icon-color, var(--calcite-accordion-item-text-color, var(--calcite-accordion-text-color, var(--calcite-color-text-3))));
  margin-inline-start: var(--calcite-internal-accordion-item-icon-spacing-start);
  margin-inline-end: var(--calcite-internal-accordion-item-icon-spacing-end);
  transform: rotate(var(--calcite-internal-accordion-item-icon-rotation));
}

.calcite--rtl .expand-icon {
  transform: rotate(var(--calcite-internal-accordion-item-icon-rotation-rtl));
}

.description {
  margin-block-start: 0.25rem;
}

.content {
  display: none;
  padding-block-start: 0px;
  text-align: initial;
}

:host(:not(:focus):not(:hover):not([expanded])) .heading {
  color: var(--calcite-accordion-item-heading-text-color, var(--calcite-accordion-item-text-color-hover, var(--calcite-color-text-2)));
}

:host([expanded]) {
  color: var(--calcite-accordion-item-text-color, var(--calcite-accordion-text-color, var(--calcite-accordion-text-color-pressed, var(--calcite-color-text-1))));
}
:host([expanded]) .header {
  border-block-end-color: transparent;
}
:host([expanded]) .expand-icon {
  color: var(--calcite-accordion-item-expand-icon-color, var(--calcite-accordion-item-text-color, var(--calcite-accordion-text-color, var(--calcite-accordion-item-text-color-hover, var(--calcite-color-text-2)))));
  transform: rotate(var(--calcite-internal-accordion-item-active-icon-rotation));
}
:host([expanded]) .calcite--rtl .expand-icon {
  transform: rotate(var(--calcite-internal-accordion-item-active-icon-rotation-rtl));
}
:host([expanded]) .description {
  color: var(--calcite-accordion-item-text-color, var(--calcite-accordion-text-color, var(--calcite-accordion-item-text-color-hover, var(--calcite-color-text-2))));
}
:host([expanded]) .content {
  display: block;
}

@media (forced-colors: active) {
  :host([expanded]) .header {
    border-block-end: none;
  }
  :host([expanded]) .heading {
    /** give visual indicator of expanded state since subtle color changes can't be done **/
    font-weight: bolder;
  }
  .header-content:hover .heading,
  .header-content:focus .heading {
    /** give visual indicator of expandability/click-ability since subtle color changes can't be done **/
    text-decoration: underline;
  }
}
:host([hidden]) {
  display: none;
}

[hidden] {
  display: none;
}